module.exports = VueGPFUP;